// Multi-worker picker for Field Jobs. The first selected worker is the lead.
export function WorkerMultiSelect({ workers, value = [], onChange, testid = "worker-multi" }) {
  const toggle = (id) =>
    onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="flex flex-wrap gap-1.5 mt-1.5" data-testid={testid}>
      {workers.length === 0 && <span className="text-xs text-slate-400">—</span>}
      {[...workers].sort((a, b) => (a.displayName || "").localeCompare(b.displayName || "")).map((w) => {
        const on = value.includes(w.id);
        const isLead = value[0] === w.id;
        return (
          <button
            type="button"
            key={w.id}
            data-testid={`${testid}-${w.id}`}
            onClick={() => toggle(w.id)}
            className={`px-2.5 py-1 rounded-full text-xs font-semibold border transition ${
              on ? "bg-brand text-white border-brand" : "bg-white border-slate-200 text-slate-600 hover:border-brand/40"
            }`}
          >
            {w.displayName}
            {isLead && <span className="ml-1 opacity-80">★</span>}
          </button>
        );
      })}
    </div>
  );
}
